import { KaiCoachBuilderSection } from '../sections/kaiCoach/KaiCoachBuilderSection';
import { KaiCoachClosingSection } from '../sections/kaiCoach/KaiCoachClosingSection';
import { KaiCoachDisciplinesSection } from '../sections/kaiCoach/KaiCoachDisciplinesSection';
import { KaiCoachFacultySection } from '../sections/kaiCoach/KaiCoachFacultySection';
import { KaiCoachFAQSection } from '../sections/kaiCoach/KaiCoachFAQSection';
import { KaiCoachHeroSection } from '../sections/kaiCoach/KaiCoachHeroSection';
import { KaiCoachLeadersSection } from '../sections/kaiCoach/KaiCoachLeadersSection';
import { KaiCoachProofSection } from '../sections/kaiCoach/KaiCoachProofSection';
import { KaiCoachResultsSection } from '../sections/kaiCoach/KaiCoachResultsSection';
import { KaiCoachRuleSection } from '../sections/kaiCoach/KaiCoachRuleSection';
import { KaiCoachSessionsSection } from '../sections/kaiCoach/KaiCoachSessionsSection';
import { KaiCoachWhySection } from '../sections/kaiCoach/KaiCoachWhySection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './KaiCoachPage.module.css';

export function KaiCoachPage() {
  useDocumentTitle('Kai Coach');

  return (
    <div className={styles.page}>
      <KaiCoachHeroSection />
      <KaiCoachProofSection />
      <KaiCoachWhySection />
      <KaiCoachSessionsSection />
      <KaiCoachRuleSection />
      <KaiCoachResultsSection />
      <KaiCoachDisciplinesSection />
      <KaiCoachFacultySection />
      <KaiCoachLeadersSection />
      <KaiCoachBuilderSection />
      <KaiCoachFAQSection />
      <KaiCoachClosingSection />
    </div>
  );
}
